import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Cadastro Argamassa',
    path: 'argamassa',
    name: 'argamassa',
    component: () => import('@/views/concreto/concreto/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroProduto],
      escopoObra: 'global'
    }
  },
  {
    description: 'Inclusão de Argamassa',
    path: 'argamassa/incluir',
    name: 'argamassainsert',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  },
  {
    description: 'Inclusão de Argamassa',
    path: 'argamassa/incluir/:id',
    name: 'argamassainsertcopy',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  },
  {
    description: 'Edição de Argamassa',
    path: 'argamassa/editar/:id',
    name: 'argamassaupdate',
    component: () => import('@/views/concreto/concreto/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroProduto],
      grupos: []
    }
  },
  {
    description: 'Fornecedor de Argamassa',
    path: 'fornecedor-obra',
    name: 'fornecedorobra-argamassa',
    component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Unidade de Argamassa',
    path: 'unidade',
    name: 'unidadeargamassa',
    component: () => import('@/views/gestao/unidade/Index.vue'),
    meta: {
      tipoFornecimento: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Unidade de Argamassa',
    path: 'unidade/incluir',
    name: 'inclusaounidadeargamassa',
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadeargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Unidade Argamassa',
    path: 'unidade/editar/:id',
    name: 'unidadeargamassaupdate',
    meta: {
      parentRouteName: 'unidadeargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade/InclusaoEdicao.vue')
  },
  {
    description: 'Unidade Tipo Argamassa',
    path: 'unidade-tipo',
    name: 'unidadetipoargamassa',
    component: () => import('@/views/gestao/unidade-tipo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra],
      grupos: [],
      ambienteRouteName: 'ambienteargamassa',
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão Unidade Tipo Argamassa',
    path: 'unidade-tipo/incluir',
    name: 'unidadetipoargamassainsert',
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'unidadetipoargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Unidade Tipo Argamassa',
    path: 'unidade-tipo/editar/:id',
    name: 'unidadetipoargamassaupdate',
    meta: {
      parentRouteName: 'unidadetipoargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra]
    },
    component: () => import('@/views/gestao/unidade-tipo/InclusaoEdicao.vue')
  },
  {
    description: 'Local de Aplicação',
    path: 'ambiente/:gesUnidadeTipoId',
    name: 'ambienteargamassa',
    component: () => import('@/views/gestao/ambiente/Index.vue'),
    goesToMenu: false,
    meta: {
      tipoFornecimento: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastrosBase],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Local de Aplicação',
    path: 'ambiente/incluir/:gesUnidadeTipoId',
    name: 'ambienteargamassainsert',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambienteargamassa',
      tipoFornecimento: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Edição de Local de Aplicação',
    path: 'ambiente/editar/:gesUnidadeTipoId/:id',
    name: 'ambienteargamassaupdate',
    component: () => import('@/views/gestao/ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ambienteargamassa',
      tipoFornecimento: 'argamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastrosBase],
      grupos: []
    }
  },
  {
    description: 'Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco',
    name: 'argamassatipoensaiofresco',
    redirect: { name: 'tipoensaioargamassa' },
    goesToMenu: false,
    meta: {
      utlTipoFornecimentoId: 3,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Inclusão de Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco/incluir',
    name: 'argamassatipoensaiofrescoinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'argamassatipoensaiofresco',
      utlTipoFornecimentoId: 3,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo de Ensaio Fresco',
    path: 'tipo-ensaio-fresco/editar/:id',
    name: 'argamassatipoensaiofrescoupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'argamassatipoensaiofresco',
      utlTipoFornecimentoId: 3,
      ensaioFresco: true,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido',
    name: 'argamassatipoensaioendurecido',
    redirect: { name: 'tipoensaioargamassa' },
    goesToMenu: false,
    meta: {
      utlTipoFornecimentoId: 3,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Inclusão de Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido/incluir',
    name: 'argamassatipoensaioendurecidoinsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'argamassatipoensaioendurecido',
      utlTipoFornecimentoId: 3,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo de Ensaio Endurecido',
    path: 'tipo-ensaio-endurecido/editar/:id',
    name: 'argamassatipoensaioendurecidoupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'argamassatipoensaioendurecido',
      utlTipoFornecimentoId: 3,
      ensaioFresco: false,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Tipo Ensaio de Argamassa',
    path: 'tipo-ensaio',
    name: 'tipoensaioargamassa',
    component: () => import('@/views/utilidade/tipoensaio/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 3,
      alternarTipoEnsaio: true,
      tipoEnsaioRouteNameFresco: 'argamassatipoensaiofresco',
      tipoEnsaioRouteNameEndurecido: 'argamassatipoensaioendurecido',
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'global'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Tipo Ensaio Argamassa',
    path: 'tipo-ensaio/incluir',
    name: 'tipoensaioargamassainsert',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaioargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Tipo Ensaio Argamassa',
    path: 'tipo-ensaio/editar/:id',
    name: 'tipoensaioargamassaupdate',
    component: () => import('@/views/utilidade/tipoensaio/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'tipoensaioargamassa',
      utlTipoFornecimentoId: 3,
      permissions: [EPermissoes.CadastroObra]
    }
  }
];
